// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"d0f0718e","453":"f666edc9"}[chunkId] + ".chunk.js";
};